import { Divider, Stack } from 'braid-design-system';
import { useState } from 'react';
import { LocationSuggest } from 'wingman-fe';

import { SectionHeadingLink } from './SectionHeadingLink/SectionHeadingLink.tsx';

import { CopyableText } from '#src/components/CopyableText/CopyableText.tsx';
import { useEnvironmentConfig } from '#src/hooks/environment.tsx';
import { TailoredForHirerText } from '#src/pages/manage/jobPosting/components/TailoredForHirerText.tsx';
import type { HiringOrganizationIdFieldsFragment } from '#src/types/generated/graphql.ts';

interface Props {
  hirer?: HiringOrganizationIdFieldsFragment;
}

export const LocationSuggestSection = ({ hirer }: Props) => {
  const { seekAnzSchemeId } = useEnvironmentConfig();

  const [oid, setOid] = useState<string>();

  return (
    <Stack space="large">
      <Stack space="medium">
        <SectionHeadingLink
          href="/use-cases/job-posting/locations#option-1-build-a-seek-specific-location-input"
          id="seek-location-suggest-heading"
        >
          Location suggest
        </SectionHeadingLink>

        {hirer ? <TailoredForHirerText hirerName={hirer.name} /> : null}
      </Stack>

      <LocationSuggest
        hirerId={hirer?.id.value}
        id="seek-location-suggest"
        label="Location"
        onSelect={(location) => setOid(location?.id.value)}
        schemeId={seekAnzSchemeId}
        showBreadcrumbs
      />

      {oid ? (
        <>
          <Divider />
          <CopyableText inlineCode>{oid}</CopyableText>
        </>
      ) : null}
    </Stack>
  );
};
